var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPremiumContributionUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.997a6.027 6.027 0 01-5-2.666c.024-1.667 3.333-2.584 5-2.584 1.666 0 4.974.917 5 2.584a6.026 6.026 0 01-5 2.666zm0-11.833a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0-2.5a8.333 8.333 0 108.333 8.333c0-4.608-3.75-8.333-8.334-8.333z",
    fill: "#FF6C01"
  })));
}

export default SvgIconPremiumContributionUser;